import { Info, X } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/** Set when the person closes the notice; never reset, so it stays closed in this browser. */
export const CUTOVER_NOTICE_DISMISSED_KEY = 'dgb-console:expenses-cutover-notice-dismissed';

function isDismissed(): boolean {
  try {
    return localStorage.getItem(CUTOVER_NOTICE_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * The move from nexpense (#917, decisions 215 and 221): from 1 November new expenses and notes go
 * here, those up to October can still be worked on in nexpense, and nexpense is read-only from
 * 1 December. Worded like nexpense's own notice. No end date is decided, so it shows until it is closed.
 */
export function CutoverNotice() {
  const { t } = useTranslation(['expenses', 'common']);
  const [dismissed, setDismissed] = useState(isDismissed);
  if (dismissed) return null;

  function dismiss() {
    try {
      localStorage.setItem(CUTOVER_NOTICE_DISMISSED_KEY, 'true');
    } catch {
      // Storage refused (private mode): the notice closes for this visit only.
    }
    setDismissed(true);
  }

  return (
    <section
      aria-label={t('expenses:cutoverNotice.label')}
      className="mb-4 flex items-start gap-3 rounded-lg bg-muted p-3 text-sm print:hidden"
    >
      <Info aria-hidden="true" className="mt-0.5 size-4 shrink-0 text-brand" />
      <p className="grow">{t('expenses:cutoverNotice.text')}</p>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="-my-1 shrink-0"
        aria-label={t('common:dismiss')}
        onClick={dismiss}
      >
        <X aria-hidden="true" />
      </Button>
    </section>
  );
}
